// @flow

import React from 'react';
import classnames from 'classnames';
import { type Props } from '.';
import './pagination.scss';

const Pagination = (props: Props) => {
  const {
    count, pageLength, pageNumber, handleNextPage, handlePreviousPage,
  } = props;
  const totalPages = Math.ceil(count / pageLength);

  const handlePreviousPageWrapper = (event) => {
    if (totalPages > 1 && pageNumber !== 0) {
      handlePreviousPage(event);
    }
  };

  const handleNextPageWrapper = (event) => {
    if (totalPages > 1 && pageNumber !== (totalPages - 1)) {
      handleNextPage(event);
    }
  };

  return (
    <div className="search-pagination">
      <button
        type="button"
        onClick={handlePreviousPageWrapper}
        className={classnames(
          'prs-icon prs-icon-thin-chevron-left search-pagination--button',
          { disabled: totalPages === 1 || pageNumber === 0 },
        )}
      />
      <p className="search-pagination--pages">
        <span className="search-pagination--at-page">{pageNumber + 1}</span>
        <span className="search-pagination--slash" />
        <span className="search-pagination--total-pages">{totalPages}</span>
      </p>
      <button
        type="button"
        onClick={handleNextPageWrapper}
        className={classnames(
          'prs-icon prs-icon-thin-chevron-right search-pagination--button',
          { disabled: totalPages === 1 || pageNumber === (totalPages - 1) },
        )}
      />
    </div>
  );
};

export default Pagination;
